import axios from "axios";

const URL = "https://staderverse.staderlabs.com";
const HEADERS = { "Content-Type": "application/json" };

const getKyvByValidator = async function (
  validator,
  timestampOffset = 0,
  timestampLimit = 20
) {
  const config = {
    method: "post",
    url: "https://us-central1-staderverse-apis-mainnet.cloudfunctions.net/kyvApiGetMetricsByValidator",
    headers: HEADERS,
    data: JSON.stringify({ validator, timestampOffset, timestampLimit }),
  };
  return await axios(config)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      console.log(error);
      throw new Error("failed to get kyv by validator");
      
    });
};
const getKyvByTimestamp = async function (
  timestamp,
  validatorOffset = 0,
  validatorLimit = 20
) {
  const config = {
    method: "post",
    url: URL + "/kyvApiGetMetricsByTimestamp",
    headers: HEADERS,
    data: JSON.stringify({ timestamp, validatorOffset, validatorLimit }),
  };
  return axios(config)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      console.log(error);
      throw new Error("failed to get kyv by timestamp");
    });
};



/* eslint import/no-anonymous-default-export: [2, {"allowObject": true}] */
export default { getKyvByTimestamp, getKyvByValidator };
